"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodePackageType = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * The types of files that can be used to detect a code package
 */
exports.CodePackageType = (0, type_utils_1.makeEnum)({
    PackageJson: 'PACKAGE_JSON',
    RequirementsTxt: 'REQUIREMENTS_TXT',
    Gradle: 'GRADLE',
    CocoaPods: 'COCOA_PODS',
    Swift: 'SWIFT',
    Pubspec: 'PUBSPEC',
    Gemfile: 'GEMFILE',
    ComposerJson: 'COMPOSER_JSON',
});
//# sourceMappingURL=code.js.map